'use client';
import { useEffect, useRef } from 'react';

import { usePageNavigationEvent } from '../components/PageNavigationEventProvider.tsx';

/**
 * 브라우저 뒤로가기를 감지해 차단하고, 앞으로가기는 허용하는 훅입니다.
 *
 * @param onBack 뒤로가기 감지 시 실행할 콜백
 */
export function useBlockBackNavigation(onBack?: () => void) {
  const isRestoringRef = useRef(false);
  const { getPreviousServicePage } = usePageNavigationEvent();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const previousServicePage = getPreviousServicePage();

    const handlePopState = () => {
      if (isRestoringRef.current) {
        isRestoringRef.current = false;
        return;
      }

      isRestoringRef.current = true;
      window.history.go(1);
      onBack?.();
    };

    if (!previousServicePage?.isExist || !previousServicePage?.page?.sameDocument) {
      window.history.pushState({ sentinal: true }, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [getPreviousServicePage, onBack]);
}
